import type { CampaignStatusModel } from 'entities/campaign';
import { CampaignStatus } from 'entities/campaign';
import { PercentageCellConfigured } from 'shared/ui/Table';

interface PercentageCellWithBadgeProps {
  className?: string;
  total: string;
  budget: string;
  refund: string;
  title: string;
  percent?: number;
  onClick?: () => void;
  campaignStatus: CampaignStatusModel;
  overbudgetTooltipContent: string;
  otherStatusesTooltipContent: string;
}

export function PercentageCellWithBadge({
  className,
  total,
  title,
  budget,
  refund,
  percent,
  onClick,
  campaignStatus,
  overbudgetTooltipContent,
  otherStatusesTooltipContent,
}: PercentageCellWithBadgeProps) {
  const isPercentageTooltipStatus =
    campaignStatus === CampaignStatus.budgetReached ||
    campaignStatus === CampaignStatus.running ||
    campaignStatus === CampaignStatus.paused ||
    campaignStatus === CampaignStatus.deactivated;

  const percentageBadgeTooltipContent = Number(percent) < 100 ? otherStatusesTooltipContent : overbudgetTooltipContent;

  return (
    <PercentageCellConfigured
      onClick={onClick}
      className={className}
      title={title}
      percent={percent}
      total={total}
      budget={budget}
      refund={refund}
      percentageBadgeTooltipContent={percentageBadgeTooltipContent}
      isPercentageTooltipStatus={isPercentageTooltipStatus}
      isFormatToCents
    />
  );
}
